<script>
  import router from '../../lib/router';
  import { onMount } from 'svelte';
  import { TS } from '../../config/translation-keys.js';
  import { t9n } from '../../lib/translate.js';
  import TabBar from '../../lib/components/TabBar.svelte';
  import Description from './components/Description.svelte';
  import Location from '../../location/Location.svelte';
  import Time from './components/Time.svelte';
  import Payment from './components/Payment.svelte';
  import Summary from './components/Summary.svelte';
  import APIClient from '../../state-charts/api-client';
  import Target from './components/Target.svelte';
  import { compareStrings } from '../../lib/utils';
  import NetsPaymentWindow from '../../lib/workpilots-ui/NetsPaymentWindow.svelte';
  import session from '../../lib/session';
  import settings from '../../config';
  import { check_tutorial, show_tutorial_screen } from '../../lib/tutorials';

  // component options  ------------------------------------------------------ //

  // internal variables ------------------------------------------------------ //

  let nets_host;
  let show_nets;
  let reserve_uuid;
  let transaction_id;
  let post_order = false;
  let orderer_amount;
  let additional_fields = [];

  let is_init_running = false;
  let current_tab = 0;
  let has_loaded_teams = false;
  let has_inited = false;
  let page_state = null;
  let copyworker = false;
  let order_id;
  let order;
  let billing;
  let credit_card;
  let label_copy;
  let label_edit;
  let back_to_original;
  let tmp_public_teams = null;
  let url_units = null;
  let url_no_payment = null;
  let has_teams_selected = false;
  let time_hours_validation = true;
  let time_next_flag = false;
  let is_team_selector_opened = false;
  let timer;
  let init_counter = false;
  let tab_history = ['init'];

  let tab_bar_items = [
    { name: null, id: 'description', icon: null, validated: true, has_used: 0 },
    { name: null, id: 'target', icon: null, validated: false, has_used: 0 },
    { name: null, id: 'location', icon: null, validated: false, has_used: 0 },
    { name: null, id: 'time', icon: null, validated: false, has_used: 0 },
    { name: null, id: 'payment', icon: null, validated: false, has_used: 0 },
    { name: null, id: 'summary', icon: null, validated: false, has_used: 0 },
  ];

  let validators = {
    payment: true,
  };

  let next_tab_disabled = {
    description: true,
    target: false,
    location: true,
    time: true,
    payment: true,
  };

  let description = {
    worker_email: '',
    is_email_valid: true,
    additional_info: null,
    team_code: '',
    is_team_code_valid: true,
    category_name: '',
    task_description: '',
    category_selector: null,
    public_teams: null,
    private_team_id: null,
    private_team_name: null,
    is_virtual: false,
    account_reference: null,
    worker_invalid_team: false,
    has_team_check_runned: false,
    no_payment: false,
  };

  let location = {
    primary_address: '',
    secondary_address: '',
    city: '',
    region: '',
    postal_code: '',
    longitude: '',
    latitude: '',
    is_address_valid: true,
  };

  let time = {
    hours: null,
    task_done: '',
  };

  let payment = {
    just_pp: false,
    items: [
      {
        name: '',
        is_enabled: true,
        payment_type: 'payment_type_pilot_points',
        is_selected: false,
      },
    ],
    has_runned: false,
  };

  // utility functions -------------------------------------------------------- //

  const finalize_payment = async reference => {
    let data = {
      amount: orderer_amount,
      reserve_uuid: reserve_uuid,
      reference: reference,
    };
    await APIClient.finalize_reserve_card(data);
    post_order = true;
    // return location.reload();
  };

  const back_to_orig_order = () => {
    router.navigate(`/order-details?id=${order_id}`);
  };

  const init_boxy = async () => {
    is_init_running = true;
    document
      .querySelector('.mdc-top-app-bar--fixed-adjust')
      .scrollIntoView({ behavior: 'smooth' });
    nets_host = settings.nets_host;
    get_page_state();

    if ($session.merchant.additional_fields.length > 0) {
      let add_fields = $session.merchant.additional_fields;
      for(let i = 0; i < add_fields.length; i++){
        if(add_fields[i].field_type === 'merchant_field_type_boolean'){
          add_fields[i].value = false;
        } else{
          add_fields[i].value = null;
        }

      }

      add_fields.forEach(e => {
        let data = e;

        if ($session.user.language === 'ar') {
          data.label = e.translation_ar;
        }
        if ($session.user.language === 'en') {
          data.label = e.translation_en;
        }
        if ($session.user.language === 'fa') {
          data.label = e.translation_fa;
        }
        if ($session.user.language === 'fi') {
          data.label = e.translation_fi;
        }
        if ($session.user.language === 'ru') {
          data.label = e.translation_ru;
        }
        if ($session.user.language === 'sv') {
          data.label = e.translation_sv;
        }
        if ($session.user.language === 'uk') {
          data.label = e.translation_uk;
        }
        if (data.label === null) {
          data.label = e.translation_en;
        }


        additional_fields.push(data);
      });



      additional_fields.sort((a, b) => {
        let keyA = a.sequence_number;
        let keyB = b.sequence_number;
        if (keyA < keyB) return -1;
        if (keyA > keyB) return 1;
        return 0;
      });
    }

    if (!!page_state) {
      get_order_id();
      get_copyworker_state();
      get_unit_state();
      get_no_payment_state();
      await load_order();
    } else {
      init_location();
    }

    translate_texts();

    let tutorials = await check_tutorial('new_order');
    if (tutorials) {
      window.localStorage.setItem('WP.tutorial.new_order', 'true');
      show_tutorial_screen(true, 'new_order_o1', 400, 'orderer', true);
    }
    has_inited = true;
    is_init_running = false;
  };

  const init_location = () => {
    location.primary_address = $session.user.address.primary_address;
    location.secondary_address = $session.user.address.secondary_address;
    location.city = $session.user.address.city;
    location.region = $session.user.address.region;
    location.postal_code = $session.user.address.postal_code;
    location.longitude = $session.user.address.longitude;
    location.latitude = $session.user.address.latitude;
    if ($session.user.address.longitude === null) {
      location.longitude = $session.merchant.country_default_longitude;
      location.latitude = $session.merchant.country_default_latitude;
    }
  };

  const get_order_id = () => {
    let url_string = window.location.href;
    let url = new URL(url_string);
    order_id = url.searchParams.get('id');
  };

  const get_page_state = () => {
    let url_string = window.location.href;
    let url = new URL(url_string);
    page_state = url.searchParams.get('state');
  };

  const get_copyworker_state = () => {
    let url_string = window.location.href;
    let url = new URL(url_string);
    copyworker = url.searchParams.get('copyworker') === 'true';
  };

  const get_unit_state = () => {
    let url_string = window.location.href;
    let url = new URL(url_string);
    url_units = parseFloat(url.searchParams.get('units'));
  };

  const get_no_payment_state = () => {
    let url_string = window.location.href;
    let url = new URL(url_string);
    url_no_payment = url.searchParams.get('no_payment') === 'true';
  };

  const get_orderer_price = () => {
    let products = $session.merchant.products;
    let tmp_price = 0;
    for (let i = 0; i < products.length; i++) {
      if (products[i].product_id === order.product.product_id) {
        tmp_price = products[i].orderer_price;
      }
    }
    tmp_price *= order.details.duration;
    return tmp_price;
  };

  const load_payment_page = async () => {
    let price = get_orderer_price();
    await APIClient.get_payment_options_with_succ({ price: price }, result => {
      if (result.options.length > 0) {
        // let items_id = 0;
        for (let i = 0; i < result.options.length; i++) {
          if (result.options[i].payment_type === 'payment_type_credit_card') {
            let is_selected =
              result.options[i].data.credit_card.credit_card_id ===
                order.payment.credit_card_id &&
              result.options[i].payment_type === order.payment.payment_type;
            payment.items[i] = {
              name:
                credit_card +
                ': ' +
                result.options[i].data.credit_card.credit_card_number,
              is_enabled: true,
              payment_type: 'payment_type_credit_card',
              credit_card_id: result.options[i].data.credit_card.credit_card_id,
              expiry_month: result.options[i].data.credit_card.expiry_month,
              expiry_year: result.options[i].data.credit_card.expiry_year,
              is_selected: is_selected,
            };
          }
          if (result.options[i].payment_type === 'payment_type_billing') {
            let is_selected =
              result.options[i].payment_type === order.payment.payment_type;
            payment.items[i] = {
              name: billing,
              is_enabled: true,
              payment_type: 'payment_type_billing',
              is_selected: is_selected,
            };
          }
          if (result.options[i].payment_type === 'payment_type_pilot_points') {
            let is_selected =
              result.options[i].payment_type === order.payment.payment_type;
            payment.items[i] = {
              name: 'PilotPoints (' + $session.user.stats.pilot_points + ')',
              is_enabled: true,
              payment_type: 'payment_type_pilot_points',
              is_selected: is_selected,
            };
          }
        }
      }
    });
  };

  const load_order = async () => {
    await APIClient.get_order({ order_uuid: order_id }, async result => {
      order = result;
      load_order_elements();
      await load_payment_page();
      if (!!url_units) {
        time.hours = url_units;

        if (order.details.teams.private.length > 0) {
          description.private_team_name = order.details.teams.private[0].name;
          description.private_team_id = order.details.teams.private[0].team_id;
        }
        current_tab = 4;
        description.worker_email =
          order.details.worker_email === null ? '' : order.details.worker_email;
      }
    });
  };

  const load_order_elements = () => {
    if (page_state === 'edit') {
      description.worker_email =
        order.details.worker_email === null ? '' : order.details.worker_email;
    }
    description.additional_info = order.details.additional_info;
    description.is_team_code_valid = true;
    description.category_name = '';
    description.task_description = order.details.description;
    description.category_selector = order.product.product_id;
    tmp_public_teams = order.details.teams.public;
    description.is_virtual = order.details.address.is_virtual;
    description.account_reference = order.details.account_reference;

    if (copyworker === true) {
      description.worker_email = order.details.worker_email;
    }
    if (order.details.teams.private.length > 0) {
      description.team_code = order.details.teams.private[0].private_code;
    }

    location.primary_address = order.details.address.primary_address;
    location.secondary_address = order.details.address.secondary_address;
    location.city = order.details.address.city;
    location.region = order.details.address.region;
    location.postal_code = order.details.address.postal_code;
    location.longitude = order.details.address.longitude;
    location.latitude = order.details.address.latitude;

    for (let i = 0; i < additional_fields.length; i++) {
      for (let j = 0; j < order.details.additional_fields.length; j++) {
        if (additional_fields[i].id === order.details.additional_fields[j].id) {
          additional_fields[i].value = order.details.additional_fields[j].value;
        }
      }
    }

    time.task_done = order.details.initial_order_time;
    time.hours = order.details.duration;
    // time.start_date = order.details.initial_start_date;
    // time.end_date = order.details.initial_end_date;

    if (!!order.details.initial_start_date) {
      time.task_done = null;
    }

    let local_start = new Date(order.details.initial_start_date).toString();
    let local_end = new Date(order.details.initial_end_date).toString();

    let start_date;
    if (!!order.details.initial_start_date) start_date = new Date(local_start);

    if (!!start_date) {
      let offset = start_date.getTimezoneOffset() / 60;

      time.start_date = `${start_date.getFullYear()}-${date_parse(
        start_date.getMonth() + 1
      )}-${date_parse(start_date.getDate())}`;
      if (!!order.details.initial_start_has_time) {
        let hour = start_date.getHours();
        if (hour >= 24) hour -= 24;
        time.start_time = `${date_parse(hour)}:${date_parse(
          start_date.getMinutes()
        )}`;
        let tmp_offset = 0 - offset;
        // if(hour < tmp_offset){
        //   time.start_date = `${start_date.getFullYear()}-${date_parse(start_date.getMonth() + 1)}-${date_parse(start_date.getDate() + 1)}`
        // }
      }
    }

    let end_date;
    if (!!order.details.initial_end_date) end_date = new Date(local_end);
    if (!!end_date) {
      let offset = end_date.getTimezoneOffset() / 60;
      time.end_date = `${end_date.getFullYear()}-${date_parse(
        end_date.getMonth() + 1
      )}-${date_parse(end_date.getDate())}`;
      if (!!order.details.initial_end_has_time) {
        let hour = end_date.getHours();
        if (hour >= 24) hour -= 24;
        time.end_time = `${date_parse(hour)}:${date_parse(
          end_date.getMinutes()
        )}`;
        let tmp_offset = 0 - offset;
        // if(hour < tmp_offset){
        //   time.end_date = `${end_date.getFullYear()}-${date_parse(end_date.getMonth() + 1)}-${date_parse(end_date.getDate() + 1)}`
        // }
      }
    }
  };

  const date_parse = val => {
    if (val < 10) return `0${val}`;
    return val;
  };

  const load_payment_elements = () => {
    for (let i = 0; i < payment.items.length; i++) {
      if (payment.items[i].payment_type === order.payment.payment_type) {
        if (payment.items[i].payment_type !== 'payment_type_credit_card') {
          payment.items[i].is_selected = true;
        } else {
          payment.items[i].is_selected = payment.items[i].name.includes(
            order.payment.credit_card_number
          );
        }
      } else {
        payment.items[i].is_selected = false;
      }
    }
  };

  window.next_tab = () => {
    is_team_selector_opened = false;
    if (current_tab === 3 && description.no_payment === true) {
      current_tab += 2;
    } else if (current_tab === 3 && url_no_payment === true) {
      current_tab += 2;
    } else {
      if (current_tab + 1 !== tab_bar_items.length) {
        if (!description.is_virtual) {
          if (
            current_tab === 0 &&
            !!order &&
            order.applications.length > 0 &&
            page_state === 'edit'
          ) {
            current_tab = 4;
          } else {
            current_tab++;
          }
        } else {
          if (current_tab === 0) {
            if (
              !!order &&
              order.applications.length > 0 &&
              page_state === 'edit'
            ) {
              current_tab += 4;
            } else {
              current_tab += 3;
            }
          } else {
            current_tab++;
          }
        }
      }
    }
  };

  window.prev_tab = () => {
    if (current_tab === 5 && description.no_payment === true) {
      current_tab -= 2;
    } else if (current_tab === 5 && url_no_payment === true) {
      current_tab -= 2;
    } else {
      if (
        current_tab === 4 &&
        !!order &&
        order.applications.length > 0 &&
        page_state === 'edit'
      ) {
        current_tab = 0;
      }
      if (current_tab !== 0) {
        if (current_tab !== 3) {
          current_tab--;
        } else {
          if (description.is_virtual) {
            current_tab -= 2;
          } else {
            current_tab--;
          }
        }
      }
    }

    if (current_tab === 1) window.open_teams();
  };

  const get_teams = async () => {
    await APIClient.get_public_teams(null, data => {
      description.public_teams = data.public_teams;
      description.public_teams.sort((a, b) => {
        return compareStrings(a.name, b.name);
      });

      for (let i = 0; i < description.public_teams.length; i++) {
        description.public_teams[i].selected = false;
      }
    });
  };

  const set_valid_tab = (id, value) => {
    // tab_bar_items.forEach(e => {
    //   if(e.id === id){
    //     e.validated = value;
    //     e.has_used++;
    //   }
    // })



    for (let i = 0; i < tab_bar_items.length; i++) {
      if (tab_bar_items[i].id === id) {
        tab_bar_items[i].validated = value;
        tab_bar_items[i].has_used++;
      }
    }

    // tab_bar_items[page].validated = value;
    // if (value) {
    //   tab_bar_items[page].has_used++;
    // }
  };

  const is_tab_valid = id => {
    let flag = false;
    tab_bar_items.forEach(e => {
      if (id === e.id) flag = e.validated;
    });
    return flag;
  };

  const select_teams = () => {
    let tmp_array = [];
    for (let i = 0; i < tmp_public_teams.length; i++) {
      tmp_array.push(tmp_public_teams[i].team_id);
    }

    for (let i = 0; i < description.public_teams.length; i++) {
      if (tmp_array.includes(description.public_teams[i].team_id)) {
        description.public_teams[i].selected = true;
      }
    }
    has_teams_selected = true;
  };

  const get_time_tab_valid = (flag) => {
    if(!!order &&
      order.applications.length > 0 &&
      page_state === 'edit'){
      return false;
    }
    return flag;
  }

  const validate_description_tab = (description, additional_fields) => {
    if (current_tab === 0) {
      let flag = false;
      if (!!description.task_description && !!description.category_selector) {
        flag = true;

        if (additional_fields.length > 0) {
          additional_fields.forEach(e => {
            if (e.is_mandatory && !e.value) flag = false;
          });
        }
      }

      // clearTimeout(timer);
      // timer = setTimeout(() => {
      set_valid_tab('target', flag);
      set_valid_tab('location', flag);
      set_valid_tab('time', get_time_tab_valid(flag));
      next_tab_disabled.description = !flag;
      // }, 750);
    }
  };

  const validate_location_tab = location => {
    if (current_tab === 2) {
      if (is_tab_valid('location')) {
        let flag = false;
        if (location.is_address_valid) {
          flag = !(
            !!order &&
            order.applications.length > 0 &&
            page_state === 'edit'
          );
        }

        // clearTimeout(timer);
        // timer = setTimeout(() => {
        set_valid_tab('time', get_time_tab_valid(flag));
        next_tab_disabled.location = !flag;
        // }, 750);
      }
    }
  };

  const validate_time_tab = (time_next_flag) => {
    if(!time_next_flag && !!order &&
      order.applications.length > 0 &&
      page_state === 'edit'){
      set_valid_tab('payment', true);
      set_valid_tab('summary', true);
    }

    if (current_tab === 3) {
      if (is_tab_valid('time')) {
        if (time_next_flag && time_hours_validation) {
          if (!description.no_payment) {
            // clearTimeout(timer);
            // timer = setTimeout(() => {
            set_valid_tab('payment', true);
            set_valid_tab('summary', true);
            // }, 750);
          } else {
            // clearTimeout(timer);
            // timer = setTimeout(() => {
            set_valid_tab('payment', false);
            set_valid_tab('summary', true);
            // }, 750);
          }
        } else {
          // clearTimeout(timer);
          // timer = setTimeout(() => {
          set_valid_tab('payment', false);
          set_valid_tab('summary', false);
          // }, 750);
        }
      }
    }
  };

  const validate_payment_tab = payment => {
    if (current_tab === 4) {
      let flag = validators.payment;
      let items = payment.items;
      items.forEach(e => {
        if (e.is_selected && validators.payment) flag = true;
      });
      set_valid_tab('summary', flag);
      next_tab_disabled.payment = !flag;
    }
  };

  const validate_target_tab = description => {
    if (current_tab === 1) {
      if (is_tab_valid('target')) {
        if (description.is_team_code_valid && description.is_email_valid) {
          // clearTimeout(timer);
          // timer = setTimeout(() => {
          next_tab_disabled.target = false;
          set_valid_tab('location', true);
          set_valid_tab('time', get_time_tab_valid(true));
          // }, 750);
        } else {
          // clearTimeout(timer);
          // timer = setTimeout(() => {
          next_tab_disabled.target = true;
          set_valid_tab('location', false);
          set_valid_tab('time', get_time_tab_valid(false));
          // }, 750);
        }
      }
    }
  };

  // const validate_summary_tab = (current_tab) => {
  //   if(current_tab === 5){
  //     set_valid_tab('description', true);
  //     set_valid_tab('target', true);
  //     set_valid_tab('location', true);
  //     set_valid_tab('time', true);
  //     set_valid_tab('payment', true);
  //   }
  // }

  // reactive functions ------------------------------------------------------- //
  $: if(current_tab || current_tab === 0) {
    tab_history.push(current_tab);
  }

  $: if (
    (description.team_code.length === 0 || description.team_code === '') &&
    description.worker_invalid_team === true
  ) {
    description.worker_invalid_team = false;
  }

  $: if (!!page_state && payment.has_runned) {
    load_payment_elements();
  }

  $: if ($session.api_config && has_loaded_teams === false) {
    (async () => {
      await get_teams();
      has_loaded_teams = true;
    })();
  }

  $: if (
    !!description.public_teams &&
    !!tmp_public_teams &&
    has_loaded_teams &&
    has_inited &&
    !has_teams_selected
  ) {
    select_teams();
  }

  $: validate_description_tab(description, additional_fields);
  $: validate_target_tab(description);
  $: validate_location_tab(location);
  $: validate_time_tab(time_next_flag);
  $: validate_payment_tab(payment);
  $: if(page_state === 'edit' && !!order){
    validate_time_tab(time_next_flag);
  }
  // $: validate_summary_tab(current_tab);

  $: if (current_tab === 2) {
    if (location.is_address_valid) {
      tab_bar_items.forEach(e => {
        if (e.id !== 'description' && e.id !== 'location') {
          if (e.has_used > 0) {
            e.validated = true;
          }
        }
      });
    } else {
      tab_bar_items.forEach(e => {
        if (e.id !== 'description' && e.id !== 'location') {
          e.validated = false;
        }
      });
    }
  }

  const translate_texts = () => {
    tab_bar_items[0].name = t9n(TS.NEW_ORDER_HEADER_DESC);
    tab_bar_items[1].name = t9n(TS.NEW_ORDER_TARGET_LABEL);
    tab_bar_items[2].name = t9n(TS.NEW_ORDER_HEADER_LOC);
    tab_bar_items[3].name = t9n(TS.NEW_ORDER_HEADER_TIME);
    tab_bar_items[4].name = t9n(TS.NEW_ORDER_HEADER_PAY);
    tab_bar_items[5].name = t9n(TS.NEW_ORDER_HEADER_SUM);
    credit_card = t9n(TS.NEW_ORDER_PAY_CARD);
    billing = t9n(TS.NEW_ORDER_WP_BILLING);
    label_copy = t9n(TS.ORDER_LABEL_COPY);
    label_edit = t9n(TS.ORDER_LABEL_EDIT);
    back_to_original = t9n(TS.ORDER_EDIT_BACK);
  };

  $: if (!has_inited && $session?.merchant && !is_init_running) {
    (async () => {
      await init_boxy();
    })();
  }
</script>

<svelte:body class="mdc-typography" />

<main>

  <div
    id="transition-outer"
    class="mdc-card wrapper fade-in transition-main"
    style="padding: 0 1rem 0 1rem;">

    {#if !!page_state}
      <div class="tooltip-state">
        <span class="fade-in-long tooltip-text">
          {#if page_state === 'copy'}{label_copy}{:else}{label_edit}{/if}
        </span>
      </div>
    {/if}

    <div id="transition-inner">

      <div style="margin-top: 0px">
        <TabBar
          padding="100px"
          bind:current_tab
          bind:tab_bar_items
          {is_team_selector_opened}
          validate={true} />
      </div>

      <div style="margin-top: 50px; margin-bottom: 24px;">
        {#if current_tab === 0}
          <Description
            has_main_init={has_inited}
            bind:task_description={description.task_description}
            bind:category_selector={description.category_selector}
            bind:category_name={description.category_name}
            bind:team_code={description.team_code}
            bind:is_team_code_valid={description.is_team_code_valid}
            bind:additional_info={description.additional_info}
            bind:worker_email={description.worker_email}
            bind:is_email_valid={description.is_email_valid}
            bind:public_teams={description.public_teams}
            bind:private_team_id={description.private_team_id}
            bind:private_team_name={description.private_team_name}
            bind:is_virtual={description.is_virtual}
            bind:acc_ref={description.account_reference}
            bind:worker_invalid_team={description.worker_invalid_team}
            bind:is_team_selector_opened
            bind:page_state
            bind:order
            bind:additional_fields
            bind:init_counter
            next_tab_disabled={next_tab_disabled.description}
            bind:no_payment={description.no_payment}
            bind:tab_history/>
        {/if}
        {#if current_tab === 1}
          <Target
            has_main_init={has_inited}
            bind:team_code={description.team_code}
            bind:is_team_code_valid={description.is_team_code_valid}
            bind:worker_email={description.worker_email}
            bind:is_email_valid={description.is_email_valid}
            bind:public_teams={description.public_teams}
            bind:private_team_id={description.private_team_id}
            bind:private_team_name={description.private_team_name}
            bind:is_virtual={description.is_virtual}
            bind:worker_invalid_team={description.worker_invalid_team}
            bind:is_team_selector_opened
            bind:page_state
            bind:order
            next_tab_disabled={next_tab_disabled.target} />
        {/if}
        {#if current_tab === 2}
          <div
            style="margin-top: -24px; margin-left: 26px; margin-bottom: -24px;">
            <Location
              bind:page_state
              bind:input={location}
              variant={'filled'}
              bind:is_address_valid={location.is_address_valid} />

          </div>
        {:else if current_tab === 3}
          <div style="margin-left: 0px;">
            <Time
              bind:category_selector={description.category_selector}
              bind:hours={time.hours}
              bind:task_done={time.task_done}
              bind:start_date={time.start_date}
              bind:end_date={time.end_date}
              bind:start_time={time.start_time}
              bind:end_time={time.end_time}
              bind:time_hours_validation
              bind:time_next_flag
              bind:page_state
              bind:order
              bind:no_payment={description.no_payment} />
          </div>
        {:else if current_tab === 4}
          <div style="margin-left: 50px;">
            <Payment
              has_main_init={has_inited}
              bind:order
              bind:page_state
              bind:category_selector={description.category_selector}
              bind:amount={time.hours}
              bind:justpp={payment.just_pp}
              bind:has_runned={payment.has_runned}
              bind:items={payment.items}
              bind:validator={validators.payment}
              next_tab_disabled={next_tab_disabled.payment} />
          </div>
        {:else if current_tab === 5}
          <Summary
            bind:reserve_uuid
            bind:show_nets
            bind:transaction_id
            bind:post_order
            bind:order
            bind:orderer_amount
            bind:worker_email={description.worker_email}
            bind:category_selector={description.category_selector}
            bind:additional_info={description.additional_info}
            bind:task_description={description.task_description}
            bind:public_teams={description.public_teams}
            bind:category_name={description.category_name}
            bind:private_team_id={description.private_team_id}
            bind:private_team_name={description.private_team_name}
            bind:is_virtual={description.is_virtual}
            bind:acc_ref={description.account_reference}
            bind:primary_address={location.primary_address}
            bind:secondary_address={location.secondary_address}
            bind:city={location.city}
            bind:region={location.region}
            bind:postal_code={location.postal_code}
            bind:longitude={location.longitude}
            bind:latitude={location.latitude}
            bind:time={time.task_done}
            bind:amount={time.hours}
            bind:start_date={time.start_date}
            bind:end_date={time.end_date}
            bind:start_time={time.start_time}
            bind:end_time={time.end_time}
            bind:page_state
            bind:order_uuid={order_id}
            bind:payment_items={payment.items}
            bind:url_units
            bind:no_payment={description.no_payment}
            bind:url_no_payment
            bind:additional_fields
            bind:teamcode={description.team_code} />
        {/if}
      </div>
    </div>
  </div>

  {#if !!page_state}
    <div id="bottom_buttons_section">
      <button
        on:click={() => back_to_orig_order()}
        class="mdc-button mdc-button--unelevated order-back-button"
        style="margin-top: 8px; width: 100%;">
        <span class="mdc-button__ripple" />
        {back_to_original}
      </button>
    </div>
  {/if}

  <NetsPaymentWindow
    {nets_host}
    {transaction_id}
    bind:show={show_nets}
    callback={finalize_payment} />
</main>

<style type="text/scss">
  /* Reset Styles
      *******************************************************/

  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    text-decoration: none;
  }

  main {
    display: flex;
    flex-direction: column;
    margin-top: 3rem !important;
    padding: 0.5rem 0.5rem;
    background: #ffffff8c;
    border-radius: 10px;
  }

  img {
    width: 100%;
  }

  .transition-main {
    transition: height 0.3s;
    overflow: hidden;
  }

  .tooltip-state {
    font-size: 12px;
    position: relative;
    transform: rotate(-6deg);
    top: 10px;
    left: -5px;
  }

  .tooltip-state .tooltip-top {
    position: absolute;
    z-index: 1;
    bottom: 100%;
    left: 50%;
    right: 0;
  }

  .tooltip-state .tooltip-text {
    color: #e65812;
    font-weight: 800;
    position: absolute;
    text-align: center;
    border: blue;
    border: dashed;
    border-radius: 6px !important;
    padding: 8px 8px !important;
  }

  /* Desktop Mode
      *******************************************************/
  @media (min-width: 1025px) {
    main {
      width: 1000px;
      margin: 0 auto;
      height: fit-content;
    }
  }

  /* Tablet Mode
      *******************************************************/
  @media (min-width: 769px) and (max-width: 1024px) {
    main {
      width: 90%;
      margin: 0 auto;
      height: fit-content;
    }

    .tooltip-state {
      top: 35px;
      left: 73px;
    }
  }

  /* Mobile Mode
      *******************************************************/
  @media (min-width: 0) and (max-width: 768px) {
    main {
      width: 100%;
      margin: 0 auto;
      height: fit-content;
      margin-bottom: 100px;
      padding: 0;
      border-radius: 0;
    }

    .tooltip-state {
      top: 50px;
      left: 72px;
    }
  }
</style>
